import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import NumberFormat from 'react-number-format';
import { customStyle, numberFormat } from 'helper';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../action';
import * as c from '../constant';


function EditPropertyAppraisalModal({
  updateData,
  getActualUseList,
  actualUseList,
  getList,
  floorAreaList,
  dataInfo,
  buildingId,
  getFloorArea,
  showAppraisalData,
  history,
  getApplicationsList,
  showData
}) {

  const [form, setForm] = useState({
    no_of_storeys: '',
    depreciation_rate: '',
    total_floor_area: '',
    unit_construction_cost: '',
    cost_of_additional_item_sub_total: '',
    sub_total_adjustment: '',
    total_construction_cost: '',
    building_core_sub_total: '',
    building_age: '',
    depreciation_cost: '',
    total_percent_depreciation: '',
    market_value: '',
  });
  const [formData, setFormData] = useState([]);
  const setModal = useContext(ModalContext);

  const RULES = {
    tab0: {
      rules: {
        no_of_storeys: 'required',
      },
    },
    tab1: {
      rules: {
        depreciation_rate: 'required',
      },
    },
  };

  const [tab, setTab] = useState(0);

  const tab0Validator = useFormValidator(
    form,
    RULES.tab0.rules,
    RULES.tab0.message
  );

  const tab1Validator = useFormValidator(
    form,
    RULES.tab1.rules,
    RULES.tab1.message
  );

  const tab0Field = _.pick(form, [
    'no_of_storeys',
  ]);

  const tab1Field = _.pick(form, [
    'depreciation_rate',
  ]);

  useEffect(() => {
    tab1Validator.validate();
  }, [Object.values(tab1Field).join(',')]);

  useEffect(() => {
    tab0Validator.validate();
  }, [Object.values(tab0Field).join(',')]);

  const validateForm = () => {
    if (tab === 0) {
      if (!tab0Validator.response.is_passed) {
        return false;
      }

      return setTab(+tab + 1);
    }

    if (tab === 1) {
      if (!tab1Validator.response.is_passed) {
        return false;
      }
    }

    return true;
  };

  const formatFloorArea = (data) => {
    const format = data.map((item, i) => ({
      id: i + 1,
      floor: _.get(item, 'attributes.floor'),
      area: _.get(item, 'attributes.area'),
      remarks: _.get(item, 'attributes.remarks'),
      rptax_actual_use_id: _.get(item, 'attributes.rptax_actual_use_id'),
      market_value: parseFloat(_.get(item, 'attributes.area').toString().replace(/,/g, '')) *
        parseFloat(_.get(dataInfo, 'attributes.unit_construction_cost').toString().replace(/,/g, '')),
    }));
    return format;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (validateForm() !== true) {
      return false;
    }

    const args = {
      ...formData,
      no_of_storeys: form.no_of_storeys,
      floor_storey_areas: formData,
      total_floor_area: form.total_floor_area,
      unit_construction_cost: form.unit_construction_cost,
      building_core_sub_total: +parseFloat((form.building_core_sub_total).toString().replace(/,/g, '')),
      sub_total_adjustment: form.sub_total_adjustment,
      total_construction_cost: form.total_construction_cost,
      depreciation_cost: form.depreciation_cost,
      depreciation_rate: form.depreciation_rate,
      total_percent_depreciation: form.total_percent_depreciation,
      market_value: form.market_value,
    };

    if (tab === 1) {
      updateData(buildingId, dataInfo.id, args, ({ data }) => {
        setModal({ isOpen: false });
        getApplicationsList({}, () => {
          getList(_.get(data, 'attributes.rptax_building_application_id'));
          getFloorArea(_.get(data, 'attributes.rptax_building_application_id'), data.id)
          showAppraisalData(_.get(data, 'attributes.rptax_building_application_id'), data.id);
          showData(_.get(data, 'attributes.rptax_building_application_id'));
          history.push(`/rpt/building/applications/${_.get(data, 'attributes.rptax_building_application_id')}`);
        });
      });
    }
    return false;
  };

  const closeModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding this record? Changes won`t be saved.',
      () => {
        setModal({ isOpen: false });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getActualUseList();
  }, []);

  const requiredActualUse = () => {
    if (!formData.every(x => _.get(x, 'rptax_actual_use_id')) || !formData.every(x => _.get(x, 'area'))) {
      return (
        <>
          <span className="font-italic mr-2" style={{ fontSize: "12px " }}>Add Actual Use and Area</span>
          <small className="text-danger">Required</small>
        </>
      )
    }
    return ""
  };

  const paginateButton = () => {
    return (
      <div className="py-1">
        {tab !== 1 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            {tab !== 0 && (
              <button
                type="button"
                onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Back
              </button>
            )}
            {tab === 0 && (
              <button
                type="button"
                onClick={closeModal}
                className="btn btn-light button-cancel-2 mr-1"
                style={{ backgroundColor: '#323943', color: '#fff' }}
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
              disabled={
                (tab === 0 && !tab0Validator.response.is_passed) ||
                (tab === 0 && requiredActualUse())
              }
            >
              Next
            </button>
          </div>
        )}
        {tab === 1 && (
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn btn-link button-cancel-2 mr-1"
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Previous
            </button>
            <button
              type="submit"
              disabled={(tab === 1 && !tab1Validator.response.is_passed)
              }
              className='btn btn-light button-proceed ml-1 cms-bg-color-primary'
              style={{ color: '#fff' }}
            >
              Submit
            </button>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (!_.isEmpty(dataInfo)) {
      setFormData(formatFloorArea(floorAreaList));

      const sumTotalConstructionCost = +parseFloat(_.get(dataInfo, 'attributes.building_core_sub_total').toString().replace(/,/g, '')) + +parseFloat(_.get(dataInfo, 'attributes.cost_of_additional_item_sub_total').toString().replace(/,/g, '')) + +parseFloat(_.get(dataInfo, 'attributes.sub_total_adjustment').toString().replace(/,/g, ''))

      setForm({
        ...form,
        total_floor_area: +_.get(dataInfo, 'included.buildingApplication.attributes.total_floor_area'),
        no_of_storeys: _.get(dataInfo, 'included.buildingApplication.attributes.no_of_storeys') || 0,
        unit_construction_cost: _.get(dataInfo, 'included.buildingApplication.attributes.unit_construction_cost') || 0,
        cost_of_additional_item_sub_total: _.get(dataInfo, 'attributes.cost_of_additional_item_sub_total') || 0,
        sub_total_adjustment: _.get(dataInfo, 'attributes.sub_total_adjustment') || 0,
        total_construction_cost: sumTotalConstructionCost || 0,
        building_core_sub_total: _.get(dataInfo, 'attributes.building_core_sub_total'),
        building_age: _.get(dataInfo, 'included.buildingApplication.attributes.building_age') || 0,
        depreciation_rate: _.get(dataInfo, 'attributes.depreciation_rate') === "0.00" ? '' : _.get(dataInfo, 'attributes.depreciation_rate'),
        depreciation_cost: +parseFloat(_.get(dataInfo, 'attributes.depreciation_cost').toString().replace(/,/g, '')) || 0,
        total_percent_depreciation: _.get(dataInfo, 'attributes.total_percent_depreciation') || 0,
        market_value: +parseFloat(_.get(dataInfo, 'attributes.market_value').toString().replace(/,/g, '')) || 0,
      });
    }
  }, []);

  const landClassificationsOptions = actualUseList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));


  const handleOnChange = (e) => {
    e.preventDefault();

    const updatedTotal = formData.reduce(
      (sum, row) => sum + Number(row.area || 0),
      0
    );

    setForm({
      ...form,
      [e.target.name]: e.target.value,
      total_floor_area: updatedTotal,
    });
  };

  const handleAddFloor = () => {
    const array = [];
    for (let i = 0; i < form.no_of_storeys; i += 1) {
      array.push({
        id: i + 1,
        floor: i + 1,
        area: '',
        market_value: '',
        remarks: '',
      });
    }
    setFormData(array);
  };

  const handleLandClassSelect = (key, index) => (e) => {
    setFormData(formData.map((item) => {
      if (+item.id === +index + 1) {
        return {
          ...item,
          [key]: e.value,
        };
      }
      return item;
    }));
  };

  const handleOnChangeRow = (key, index) => (e) => {

    const updatedFormData = formData.map((item) => {
      if (+item.id === +index + 1) {
        const updatedItem = { ...item, [key]: e.target.value };

        if (key === "area") {
          updatedItem.market_value = +updatedItem.area * +form.unit_construction_cost;
        }

        return updatedItem;
      }
      return item;
    });

    setFormData(updatedFormData);

    const updatedTotal = updatedFormData.reduce(
      (sum, row) => sum + Number(row.area || 0),
      0
    );

    const updatedSubTotal = updatedFormData.reduce(
      (sum, row) => sum + Number(row.market_value || 0),
      0
    );

    const updatedTotalConstruction = +parseFloat(form.cost_of_additional_item_sub_total).toString().replace(/,/g, '') +
      +form.sub_total_adjustment + +updatedSubTotal;

    const updatedMarketValue = +updatedTotalConstruction - +form.depreciation_cost;

    setForm({
      ...form,
      total_floor_area: updatedTotal,
      building_core_sub_total: updatedSubTotal,
      total_construction_cost: updatedTotalConstruction,
      market_value: updatedMarketValue
    });
  };

  const handleRemove = () => {
    const newItem = formData.slice(0, -1);
    setFormData(newItem);

    const updatedTotal = formData.reduce(
      (sum, row) => sum + Number(row.area || 0),
      0
    );

    const updatedSubTotal = formData.reduce(
      (sum, row) => sum + Number(row.market_value || 0),
      0
    );

    const updatedTotalConstruction = +form.cost_of_additional_item_sub_total +
      +form.sub_total_adjustment + +updatedSubTotal;

    setForm({
      ...form,
      no_of_storeys: formData.length - 1 || '',
      total_floor_area: updatedTotal,
      building_core_sub_total: updatedSubTotal,
      total_construction_cost: updatedTotalConstruction
    });
  };

  const MAX_PERCENTAGE = 100;
  const percentageCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= MAX_PERCENTAGE) return true;
    return false;
  };

  const handleOnAddRow = (el) => (e) => {
    e.preventDefault();

    setFormData(
      (formData || []).concat([
        {
          id: formData.length + 1,
          floor: el.floor,
          rptax_actual_use_id: '',
          rptax_building_component_id: '',
          area: 0,
          rate: 0,
          is_add_area: 0,
        },
      ]),
    );
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="m-1 p-1">
          {tab === 0 && (
            <>
              <div className="row">
                <div className="col-6 form-group">
                  <label className="form-label">
                    No of Storeys {tab0Validator.renderMessage(
                      'no_of_storeys'
                    )}
                  </label>
                  <div
                    className="input-group mb-3 col-12 mt-2"
                    style={{ marginLeft: -15 }}
                  >
                    <input
                      className="form-control"
                      type="number"
                      id="no_of_storeys"
                      name="no_of_storeys"
                      autoComplete="none"
                      onChange={handleOnChange}
                      value={form.no_of_storeys}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        onClick={handleAddFloor}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold"
                      >
                        <i className="fas fa-plus" /> Add
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <label className="form-label">
                    Total Floor Area
                  </label>
                  <input
                    readOnly
                    className="form-control"
                    type="number"
                    id="totalEditPropertyAppraisalModal"
                    name="totalEditPropertyAppraisalModal"
                    autoComplete="none"
                    value={form.total_floor_area || 0}
                  />
                </div>
                <div className="col-12">
                  <table className="table-lease table table-sm mt-2 scroll-table">
                    <thead>
                      <tr className="cms-bg-color-primary-light cms-text-primary">
                        <th>Floor</th>
                        <th>Actual Use</th>
                        <th>Area</th>
                        <th>Market Value</th>
                        <th>Remarks</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {(formData || []).map((el, index) => (
                        <tr key={`floor-${el.id}`}>
                          <td>
                            {el.floor}
                          </td>
                          <td width="250">
                            <Select
                              options={landClassificationsOptions}
                              styles={customStyle}
                              placeholder="Select Actual Use"
                              value={
                                landClassificationsOptions.filter(
                                  (item) =>
                                    +_.get(el, 'rptax_actual_use_id') === +_.get(item, 'id')
                                ) || ''
                              }
                              onChange={handleLandClassSelect('rptax_actual_use_id', index)}
                            />
                          </td>
                          <td width="100">
                            <input
                              className="form-control"
                              type="number"
                              id="area"
                              name="area"
                              autoComplete="none"
                              onChange={handleOnChangeRow('area', index)}
                              value={_.get(el, 'area') || ''}
                            />
                          </td>
                          <td>
                            <span className="title-color mt-2">
                              {_.get(el, 'market_value')
                                ? parseFloat(
                                  _.get(el, 'market_value')
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : '0.00'}
                            </span>
                          </td>
                          <td width="350">
                            <input
                              className="form-control"
                              type="text"
                              id="remarks"
                              name="remarks"
                              autoComplete="none"
                              onChange={handleOnChangeRow('remarks', index)}
                              value={_.get(el, 'remarks') || ''}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              onClick={handleOnAddRow(el)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto mr-2"
                            >
                              <i className="fas fa-edit" /> Add Floor
                            </button>
                          </td>
                          {(floorAreaList.length === index + 1) && (
                            <td>
                              <button type="button" className="btn btn-blank" onClick={handleRemove}>
                                <i className="far fa-trash-alt icon-delete" />
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-12 mt-5">
                  <table className="appraisal-table table table-bordered table-sm">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="350">
                          Unit Construction Cost
                        </td>
                        <td width="100">
                          <span className="title-color">
                            {_.get(form, 'unit_construction_cost')
                              ? parseFloat(
                                _.get(form, 'unit_construction_cost')
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : '0.00'}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Sub Total
                        </td>
                        <td width="100">
                          <span className="title-color">
                            {numberFormat(
                              _.reduce(
                                formData,
                                (total, b) =>
                                  b.market_value +
                                  total,
                                0
                              ),
                              2
                            )}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
          {tab === 1 && (
            <>
              <div className="row mt-4">
                <div className="col-12 mt-1">
                  <span className="title-color">Property Appraisal Breakdown </span>
                </div>
                <div className="col-12 px-3 mt-2">
                  <table className="appraisal-table table table-sm">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="350">
                          Cost of Additional Items
                        </td>
                        <td width="100">
                          <span className="title-color">
                            {_.get(form, 'cost_of_additional_item_sub_total') || '0.00'}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Sub-Total Adjustment
                        </td>
                        <td width="100">
                          <span className="title-color">
                            PHP{' '}{_.get(form, 'sub_total_adjustment')
                              ? parseFloat(
                                _.get(form, 'sub_total_adjustment')
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : '0.00'}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Total Construction Cost
                        </td>
                        <td width="100">
                          <span className="title-color">
                            PHP{' '}{_.get(form, 'total_construction_cost')
                              ? parseFloat(
                                _.get(form, 'total_construction_cost')
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : '0.00'}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-12 px-3 mt-2">
                  <table className="appraisal-table table table-sm">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="350">
                          Depreciation Rate {tab1Validator.renderMessage(
                            'depreciation_rate'
                          )}
                        </td>
                        <td width="100">
                          <NumberFormat
                            name="depreciation_rate"
                            id="depreciation_rate"
                            placeholder="0"
                            className="form-control"
                            onValueChange={(values) => {
                              const { floatValue } = values;

                              const depreciationRate = +floatValue / 100;
                              const updatedTotalMarketValue = formData.reduce(
                                (sum, row) => sum + Number(row.market_value || 0),
                                0
                              );

                              if (form.building_age === 0) {
                                setForm({
                                  ...form,
                                  depreciation_rate: floatValue > 0 ? floatValue : '',
                                  total_percent_depreciation: floatValue,
                                  depreciation_cost: +form.total_construction_cost * depreciationRate,
                                  market_value: +form.total_construction_cost - (+form.total_construction_cost * depreciationRate),
                                  building_core_sub_total: updatedTotalMarketValue
                                });
                              } else {
                                setForm({
                                  ...form,
                                  depreciation_rate: floatValue > 0 ? floatValue : '',
                                  total_percent_depreciation: +form.building_age *
                                    +floatValue,
                                  depreciation_cost: +form.total_construction_cost * +form.building_age *
                                    +depreciationRate,
                                  market_value: +form.total_construction_cost - (+form.total_construction_cost * +form.building_age *
                                    +depreciationRate),
                                  building_core_sub_total: updatedTotalMarketValue
                                });
                              }
                            }}
                            isAllowed={percentageCap}
                            isNumericString
                            thousandSeparator
                            allowNegative={false}
                            allowLeadingZeros={false}
                            displayType="input"
                            prefix=""
                            value={_.get(form, 'depreciation_rate')?.toString() || ''}
                            suffix="%"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="350">
                          Depreciation Cost
                        </td>
                        <td width="100">
                          <span className="title-color">
                            PHP{' '}{_.get(form, 'depreciation_cost')
                              ? parseFloat(
                                _.get(form, 'depreciation_cost')
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : '0.00'}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Total % Depreciation
                        </td>
                        <td width="100">
                          <span className="title-color">
                            {_.get(form, 'total_percent_depreciation') || ''} %
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Market Value
                        </td>
                        <td width="100">
                          <span className="title-color">
                            PHP{' '}{_.get(form, 'market_value')
                              ? parseFloat(
                                _.get(form, 'market_value')
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : '0.00'}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr className="below-hr" />
              {paginateButton()}
            </>
          )}
        </div>
      </form>
    </Modal.Body>
  );
}

EditPropertyAppraisalModal.defaultProps = {
  buildingId: '',
  dataInfo: {},
  floorAreaList: [],
};

EditPropertyAppraisalModal.propTypes = {
  updateData: PropTypes.instanceOf(Function).isRequired,
  getActualUseList: PropTypes.instanceOf(Function).isRequired,
  actualUseList: PropTypes.instanceOf(Array).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  buildingId: PropTypes.string,
  floorAreaList: PropTypes.instanceOf(Array),
  dataInfo: PropTypes.instanceOf(Object),
  getFloorArea: PropTypes.instanceOf(Function).isRequired,
  showAppraisalData: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getApplicationsList: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  actualUseList: _.get(api, `${c.GET_ACTUAL_USE_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(EditPropertyAppraisalModal);